import React, { Fragment, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';


export default function ReCaptcha({ setCaptchaValue, sitekey, lang, onValidated, outerClass, wrapperClass }) {
    const _reCaptchaRef = React.createRef();
    const [ load, setLoad ] = useState(false);
    const [ expired, setExpired ] = useState(true);
    const [ value, setValue ] = useState('');
    const [ errorValue, setErrorValue ] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setLoad(true);
        }, 100);
    },[]);

    const handleChange = value => {
        if(value && typeof onValidated==='function'){
            onValidated();
        }
        setValue(value);
        setCaptchaValue(value);
        if (value === null) { setExpired(true); }
    };

    const handleError = value => {
        setErrorValue(value);
    };
    // const asyncScriptOnLoad = () => {
    //     console.log("scriptLoad - reCaptcha Ref-", _reCaptchaRef);
    // };

    if(value && expired && errorValue) {
        const testValues = () => <Fragment> {value} {expired} </Fragment>;
        console.log(testValues);
    }

    return (
        <div className='grid-row'>
            <div className={`g-recaptcha ${outerClass}`}>
                <div className={`recaptcha-wrapper ${wrapperClass}`}  data-size='compact'>
                    {load &&
                    <ReCAPTCHA
                        ref={ _reCaptchaRef }
                        sitekey={ sitekey }
                        hl={lang}
                        onChange={ handleChange }
                        onErrored={ handleError }
                        //asyncScriptOnLoad={asyncScriptOnLoad}
                    />
                    }
                </div>
            </div>
        </div>

    );

}
